var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-chart-container"},[_c('div',{ref:"pieChart",staticClass:"chart",attrs:{"id":"dv"}}),(_vm.resultList.length<=0)?_c('div',{staticClass:"ok-text"},[_vm._v("暂无问题，请继续保持。")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }